var map = {
	"./404.gif": [
		2153,
		153
	],
	"./404.png": [
		6682
	],
	"./Food_Wine_Pairing.webp": [
		2381,
		381
	],
	"./NovusLoader.gif": [
		1197,
		197
	],
	"./Tahola-ai.png": [
		4900
	],
	"./TaholaLoader.gif": [
		9317
	],
	"./TaholaXmas.png": [
		9334,
		334
	],
	"./Tahola_Logo_transparent - original.png": [
		3406,
		406
	],
	"./Tahola_Logo_transparent.png": [
		1950
	],
	"./Tahola_Logo_transparent_powered_by.png": [
		4407,
		407
	],
	"./building_1.gif": [
		3751
	],
	"./building_2.gif": [
		3088,
		88
	],
	"./building_3.gif": [
		8905,
		905
	],
	"./contact-us.png": [
		2977
	],
	"./cropped-icon-1-180x180.png": [
		3612,
		612
	],
	"./cropped-icon-1-192x192.png": [
		9140,
		140
	],
	"./cropped-icon-1-270x270.png": [
		5008,
		8
	],
	"./cropped-icon-1-32x32.png": [
		1990,
		990
	],
	"./csv_icon.png": [
		2524
	],
	"./food_background.png": [
		1993,
		993
	],
	"./illustration.jpg": [
		4610,
		610
	],
	"./jedox-icon.png": [
		2626
	],
	"./novus_red_wine_glass_background.jpg": [
		8807,
		807
	],
	"./qalyptus-icon.png": [
		5085
	],
	"./qlik-icon.png": [
		573
	],
	"./snowflake-icon.png": [
		7118
	],
	"./tahola-t.png": [
		8012,
		12
	],
	"./tahola_logo.svg": [
		1937,
		937
	],
	"./taholaconnect-icon.png": [
		515
	],
	"./under-constraction.png": [
		7916
	],
	"./xlsx_icon.png": [
		3125
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8388;
module.exports = webpackAsyncContext;